module.exports = __webpack_public_path__ + "static/img/Isaiya-Katoa.20eee40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaiya-Katoa.jpg
// module id = GAN6
// module chunks = 0